// Generated by purs version 0.15.15
import * as Data_Eq from "../Data.Eq/index.js";
import * as Halogen_Svg_Attributes_CSSLength from "../Halogen.Svg.Attributes.CSSLength/index.js";
var eq = /* #__PURE__ */ Data_Eq.eq(Halogen_Svg_Attributes_CSSLength.eqCSSLength);
var XXSmall = /* #__PURE__ */ (function () {
    function XXSmall() {

    };
    XXSmall.value = new XXSmall();
    return XXSmall;
})();
var XSmall = /* #__PURE__ */ (function () {
    function XSmall() {

    };
    XSmall.value = new XSmall();
    return XSmall;
})();
var Small = /* #__PURE__ */ (function () {
    function Small() {

    };
    Small.value = new Small();
    return Small;
})();
var Medium = /* #__PURE__ */ (function () {
    function Medium() {

    };
    Medium.value = new Medium();
    return Medium;
})();
var Large = /* #__PURE__ */ (function () {
    function Large() {

    };
    Large.value = new Large();
    return Large;
})();
var XLarge = /* #__PURE__ */ (function () {
    function XLarge() {

    };
    XLarge.value = new XLarge();
    return XLarge;
})();
var XXLarge = /* #__PURE__ */ (function () {
    function XXLarge() {

    };
    XXLarge.value = new XXLarge();
    return XXLarge;
})();
var Smaller = /* #__PURE__ */ (function () {
    function Smaller() {

    };
    Smaller.value = new Smaller();
    return Smaller;
})();
var Larger = /* #__PURE__ */ (function () {
    function Larger() {

    };
    Larger.value = new Larger();
    return Larger;
})();
var FontSizeLength = /* #__PURE__ */ (function () {
    function FontSizeLength(value0) {
        this.value0 = value0;
    };
    FontSizeLength.create = function (value0) {
        return new FontSizeLength(value0);
    };
    return FontSizeLength;
})();
var showFontSize = {
    show: function (v) {
        if (v instanceof XXSmall) {
            return "XXSmall";
        };
        if (v instanceof XSmall) {
            return "XSmall";
        };
        if (v instanceof Small) {
            return "Small";
        };
        if (v instanceof Medium) {
            return "Medium";
        };
        if (v instanceof Large) {
            return "Large";
        };
        if (v instanceof XLarge) {
            return "XLarge";
        };
        if (v instanceof XXLarge) {
            return "XXLarge";
        };
        if (v instanceof Smaller) {
            return "Smaller";
        };
        if (v instanceof Larger) {
            return "Larger";
        };
        if (v instanceof FontSizeLength) {
            return "(FontSizeLength " + (Halogen_Svg_Attributes_CSSLength.printCSSLength(v.value0) + ")");
        };
        throw new Error("Failed pattern match at Halogen.Svg.Attributes.FontSize (line 24, column 10 - line 34, column 70): " + [ v.constructor.name ]);
    }
};
var printFontSize = function (v) {
    if (v instanceof XXSmall) {
        return "xx-small";
    };
    if (v instanceof XSmall) {
        return "x-small";
    };
    if (v instanceof Small) {
        return "small";
    };
    if (v instanceof Medium) {
        return "medium";
    };
    if (v instanceof Large) {
        return "large";
    };
    if (v instanceof XLarge) {
        return "x-large";
    };
    if (v instanceof XXLarge) {
        return "xx-large";
    };
    if (v instanceof Smaller) {
        return "smaller";
    };
    if (v instanceof Larger) {
        return "larger";
    };
    if (v instanceof FontSizeLength) {
        return Halogen_Svg_Attributes_CSSLength.printCSSLength(v.value0);
    };
    throw new Error("Failed pattern match at Halogen.Svg.Attributes.FontSize (line 37, column 17 - line 47, column 39): " + [ v.constructor.name ]);
};
var eqFontSize = {
    eq: function (x) {
        return function (y) {
            if (x instanceof XXSmall && y instanceof XXSmall) {
                return true;
            };
            if (x instanceof XSmall && y instanceof XSmall) {
                return true;
            };
            if (x instanceof Small && y instanceof Small) {
                return true;
            };
            if (x instanceof Medium && y instanceof Medium) {
                return true;
            };
            if (x instanceof Large && y instanceof Large) {
                return true;
            };
            if (x instanceof XLarge && y instanceof XLarge) {
                return true;
            };
            if (x instanceof XXLarge && y instanceof XXLarge) {
                return true;
            };
            if (x instanceof Smaller && y instanceof Smaller) {
                return true;
            };
            if (x instanceof Larger && y instanceof Larger) {
                return true;
            };
            if (x instanceof FontSizeLength && y instanceof FontSizeLength) {
                return eq(x.value0)(y.value0);
            };
            return false;
        };
    }
};
export {
    XXSmall,
    XSmall,
    Small,
    Medium,
    Large,
    XLarge,
    XXLarge,
    Smaller,
    Larger,
    FontSizeLength,
    printFontSize,
    eqFontSize,
    showFontSize
};
